import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DocumentTypeCodeDto, DocumentTypeDto, FiscalFileLocationDto, LandTitleDto, LandTitleRegisterDto, SecurityClassificationDto } from '@cradua/data';
import * as XLSX from "xlsx";
import { ExcelDocumentUploadViewComponent } from './excel-document-upload-view/excel-document-upload-view.component';
type AOA = any[][];

@Component({
  selector: 'cradua-document-table',
  templateUrl: './document-table.component.html',
  styleUrls: ['./document-table.component.scss']
})
export class DocumentTableComponent implements OnInit {

  @Input() fetchDocuments: LandTitleRegisterDto[];
  @Input() documentTypeCodes: DocumentTypeCodeDto[];
  @Input() documentTypes: DocumentTypeDto[];
  @Input() selectedLandTitle: LandTitleDto;
  @Input() securityClassifications: SecurityClassificationDto[];
  @Input() fileLocations: FiscalFileLocationDto[];
  @Output() emitSelectDoc = new EventEmitter<any>();
  @Output() emitEdit = new EventEmitter<any>();
  @Output() emitUploadDoc = new EventEmitter<any>();
  @Output() emitSaveManyDoc = new EventEmitter<any>();

  documentArrayForm: FormGroup;
  selectedIndex = null;
  fileName = "SheetJS.xlsx";
  uploadDocuments: any[];
  data: any;
  listView = false;
  gridView = true;
  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog
    ) { }

  ngOnInit(): void {
    this.documentArrayForm = this.fb.group({Documents: this.fb.array([])});
    if(this.fetchDocuments != null && this.fetchDocuments.length) {
      this.setFileLocation(this.fetchDocuments);
    }
  }


  get storageLocationFormArray() {
    return this.documentArrayForm.get('Documents') as FormArray;
  }

  onEdit(value, index) {
    this.selectedIndex = index;
    const newValue = value.Documents[index];
    this.emitEdit.emit(newValue);
  }


  setFileLocation(documents: LandTitleRegisterDto[]) {
    documents.forEach(doc => {
      this.storageLocationFormArray.push(this.fb.group({
      DocumentTitle: doc.DocumentTitle,
      DocumentTypeCodeId: doc.DocumentTypeCodeId,
      DocumentTypeId: doc.DocumentTypeId,
      SecurityId: doc.SecurityId,
      FileLocationId: doc.FileLocationId,
      Remarks: doc.Remarks,
      Url: doc.Url,
      DocRefNo: doc.DocRefNo,
      FileName: doc.FileName,
      FilePath: doc.FilePath,
      FileType: doc.FileType,
      id: doc.id
      }));
    });
  }

  onSelectDoc(value: LandTitleRegisterDto) {
    this.emitSelectDoc.emit(value);
  }

  onList() {
    this.listView = true;
    this.gridView = false;
  }

  onGrid() {
    this.gridView = true;
    this.listView = false;
  }

  protected filterById = <T>(id: string, lookupId: string) =>
  (fieldName: T) => fieldName[lookupId] === id;

  getDocumentTypeName(id: string) {
    const found = this.documentTypes.find(
      this.filterById<DocumentTypeDto>(id, "id"),
    );
    return found ? found.DocumentTypeName : null;
    }

    getDocumentTypeCodeName(id: string) {
      const found = this.documentTypeCodes.find(
        this.filterById<DocumentTypeCodeDto>(id, "id"),
      );
      return found ? found.DocumentTypeCodeName : null;
      }

      getSecurityClassificationName(id: string) {
        const found = this.securityClassifications.find(
          this.filterById<SecurityClassificationDto>(id, "id"),
        );
        return found ? found.SecurityClassificationName : null;
        }

      getFileLocationName(id: string) {
        const found = this.fileLocations.find(
          this.filterById<FiscalFileLocationDto>(id, "id"),
        );
        return found ? found.FileLocationName : null;
        }



  onUploadDoc(doc) {
    const dialogConfig = new MatDialogConfig();
    // dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "90%";
    dialogConfig.width = "100%";
    // dialogConfig.minHeight = '100vh';
    // dialogConfig.minWidth = '100%'
    dialogConfig.panelClass = "custom-dialog-container";
    dialogConfig.backdropClass = "backdropBackground";

    dialogConfig.data = {
      doc,
      documentTypes: this.documentTypes,
      documentTypeCodes: this.documentTypeCodes,
      securityClassifications: this.securityClassifications,
      fileLocations: this.fileLocations,

    }

    const dialogRef = this.dialog.open(
      ExcelDocumentUploadViewComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result) => {
      // console.log('result got ', result);
      if(result !== undefined) {

       this.uploadDocuments = result;

     const transformDoc =  result.map(doc => {
       if(doc.id != null) {
        return {
          DocumentTitle:  doc.DocumentTitle,
          DocumentTypeCodeId:  this.getDocumentTypeCodeId(doc.DocumentTypeCode),
          DocumentTypeId:  this.getDocumentTypeId(doc.DocumentType),
          SecurityId:  this.getSecurityId(doc.Security),
          FileLocationId: this.getFileLocationId(doc.FileLocation),
          Remarks: doc.Remarks,
          Url: doc.Url,
          FileName: doc.FileName,
          DocRefNo: doc.DocRefNo,
          FilePath: doc.FilePath,
          FileType: doc.FileType,
            id: doc.id
         }
       } else{
       return {
        DocumentTitle:  doc.DocumentTitle,
        DocumentTypeCodeId:  this.getDocumentTypeCodeId(doc.DocumentTypeCode),
        DocumentTypeId:  this.getDocumentTypeId(doc.DocumentType),
        SecurityId:  this.getSecurityId(doc.Security),
        FileLocationId: this.getFileLocationId(doc.FileLocation),
        Remarks: doc.Remarks,
        Url: doc.Url,
        FileName: doc.FileName,
        DocRefNo: doc.DocRefNo,
        FilePath: doc.FilePath,
        FileType: doc.FileType,
        LandTitleCode: this.selectedLandTitle.id,
          id: doc.id
       }
      }
     })
  console.log('result got 1', transformDoc);
       this.emitSaveManyDoc.emit(transformDoc);
      }

    });
  }

  export(): void {
    const transformDoc = this.fetchDocuments.map(doc => {
      return {
        id: doc.id,
        DocumentTitle: doc.DocumentTitle,
        DocumentTypeCode: this.getDocumentTypeCodeName(doc.DocumentTypeCodeId),
        DocumentType: this.getDocumentTypeName(doc.DocumentTypeId),
        Security: this.getSecurityClassificationName(doc.SecurityId),
        FileLocation: this.getFileLocationName(doc.FileLocationId),
        Remarks: doc.Remarks,
        Url: doc.Url,
        DocRefNo: doc.DocRefNo,
        FileName: doc.FileName,
        FilePath: doc.FilePath,
        FileType: doc.FileType
      }
    })
    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(transformDoc);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
  }



  getDocumentTypeId(value: string) {
    if (value) {
      const foundDocumentType = this.documentTypes.find(
        (docType) =>
        docType.DocumentTypeName &&
        docType.DocumentTypeName.trim().toLowerCase() ===
            value.trim().toLowerCase(),
      );
      return foundDocumentType ? foundDocumentType.id : null;
    } else {
      return null;
    }
  }

  getDocumentTypeCodeId(value: string) {
    if (value) {
      const foundDocumentTypeCode = this.documentTypeCodes.find(
        (docTypeCode) =>
        docTypeCode.DocumentTypeCodeName &&
        docTypeCode.DocumentTypeCodeName.trim().toLowerCase() ===
            value.trim().toLowerCase(),
      );
      return foundDocumentTypeCode ? foundDocumentTypeCode.id : null;
    } else {
      return null;
    }
  }

  getFileLocationId(value: string) {
    if (value) {
      const foundFileLocation = this.fileLocations.find(
        (fileLocation) =>
        fileLocation.FileLocationName &&
        fileLocation.FileLocationName.trim().toLowerCase() ===
            value.trim().toLowerCase(),
      );

      return foundFileLocation ? foundFileLocation.id : null;
    } else {
      return null;
    }
  }


  getSecurityId(value: string) {
    if (value) {
      const foundSecurityClassification = this.securityClassifications.find(
        (securityClassification) =>
        securityClassification.SecurityClassificationName &&
        securityClassification.SecurityClassificationName.trim().toLowerCase() ===
            value.trim().toLowerCase(),
      );

      return foundSecurityClassification ? foundSecurityClassification.id : null;
    } else {
      return null;
    }
  }



}
